import { HttpStatusCode } from "@angular/common/http";

export interface OrderByModel {
  fieldName?: string | null;
  sortType?: PagingSortType;
}

export type PagingSortType = 1 | 2;

export interface BaseResponse {
  message?: string | null;
  resultCode?: number;
  resultCodeType?: string | null;
  status?: HttpStatusCode;
  userErrorCode?: string | null;
  userPod?: string | null;
  apiResponseTime?: string | null;
}

export interface GetListRequest<TFilter> {
  filter?: TFilter;

  /** @format int32 */
  pageSize?: number | null;

  /** @format int32 */
  pageIndex?: number | null;
  orderByModel?: OrderByModel[] | null;
  countRequired?: boolean;

  /** @format int32 */
  timeZone?: number;

  /** @format int32 */
  maxRecordsLimit?: number;
}

export interface GetListResponse<TDataList> extends BaseResponse {
  totalCount?: number;
  dataList?: TDataList[] | null;
}

export interface DeleteRequest {
  id: number;
  system_RowVersion?: string;
}
